<i
    [ngClass]="{
        'material-icons': result?.isMaterial,
        fa: result?.isFontawesome,
        'fa-spinner fa-spin': result?.isFASpinner,
        'green': result?.isSuccess,
        'yellow': result?.isWarning,
        'red': result?.isError,
        'orange': result?.isAccent
    }"
    [title]="MessageSubject.asObservable() | async"
    >{{ result?.icon }}</i
>
